import React from 'react';
import {NumberInputContext} from './NumberInputContext';
import {useNumberInput} from '../_hooks';
import type {NumberInputProviderProps} from '../_types';

/**
 * # NumberInputProvider
 *
 * The purpose of NumberInputProvider is to wrap any numeric input component, giving its child nodes access to plug-and-play state, and logic out-of-the-box.
 *
 */
export const NumberInputProvider = React.forwardRef<
  HTMLInputElement,
  NumberInputProviderProps
>(
  (
    {
      children,
      isDisabled,
      isError,
      max,
      min,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      precision,
      prefix,
      shouldAllowWheelAdjustment,
      shouldShowTrailingControls,
      skipMultiplier,
      step,
      suffix,
      value,
      variant,
    }: NumberInputProviderProps,
    ref
  ) => {
    const numberInputState = useNumberInput({
      isDisabled,
      isError,
      max,
      min,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      precision,
      prefix,
      ref,
      shouldAllowWheelAdjustment,
      shouldShowTrailingControls,
      skipMultiplier,
      step,
      suffix,
      value,
      variant,
    });

    return (
      <NumberInputContext.Provider value={numberInputState}>
        {children}
      </NumberInputContext.Provider>
    );
  }
);
